import React from 'react'
import { connect } from 'react-redux'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { RootState } from 'typedRedux/configureStoreWithHistory'

import { changePassword } from 'actions/authActions'
import { HeadingLg, ParagraphXs } from 'components/display/Typography'
import { renderTextField, Submit } from 'components/form'
import { validRequired, validEmail } from 'components/form/validate'

import { AuthToken } from '../shared'
import { FieldWrapper } from '../styles'

interface ResetPasswordFormFormValues {
  user: {
    email: string
  }
}

interface ResetPasswordFormProps {
  onSuccess: () => any
}

const ResetPassword = ({ handleSubmit }: InjectedFormProps) => {
  return (
    <form
      className="qa-login"
      action="/users/password"
      method="post"
      onSubmit={handleSubmit}
    >
      <FieldWrapper>
        <HeadingLg noMargin>Forgot your password?</HeadingLg>
        <ParagraphXs noMargin notResponsive>
          Enter the email address you used when you joined and we’ll send you
          instructions to reset your password.
        </ParagraphXs>
      </FieldWrapper>

      <AuthToken />

      <FieldWrapper margin="medium">
        <Field
          label="Email"
          name="user[email]"
          type="email"
          component={renderTextField}
          validate={[validRequired, validEmail]}
          noMargin
        />
      </FieldWrapper>

      <FieldWrapper>
        <Submit name="commit" fullwidth uppercase={false}>
          Send reset link
        </Submit>
      </FieldWrapper>
    </form>
  )
}

const ResetPasswordForm = reduxForm({
  form: 'ResetPassword',
})(ResetPassword)

export default connect(
  ({ auth }: { auth: { currentUser: RootState['auth']['currentUser'] } }) => ({
    currentUser: auth.currentUser,
  }),
  (dispatch, { onSuccess }: ResetPasswordFormProps) => ({
    onSubmit: (formValues: ResetPasswordFormFormValues) =>
      // @ts-ignore -- changePassword not typed
      dispatch(changePassword(formValues)).then(onSuccess),
  })
)(ResetPasswordForm)
